import ScatterPlot from './ScatterPlot';

export default ScatterPlot;